import {formatBytes} from "@/utils/helpers.service";

export function loadChatbot () {
  if (document.getElementById("widget-chatbot-js")) return // Évite de charger plusieurs fois

  const script = document.createElement("script")
  script.id = "widget-chatbot-js"
  script.src = "https://www.talkia.tech/js/conversation/widget.js?v=1"
  script.setAttribute("company-slug", "wuro")
  script.setAttribute("chatbot-slug", "w03-rh")
  script.setAttribute("port", "3004")
  script.setAttribute("chatbot-url", "https://www.talkia.tech")
  script.setAttribute("display", "classic")
  script.setAttribute("defer", true)
  script.setAttribute("onload-display", "close")

  document.body.appendChild(script)
}

export function addChatBotMetaData (rootState) {
  const metaData = {
    company_name: null,
    company_url: null,
    current_versions: [],
    nb_documents: null,
    nb_invoices: null,
    nb_quotes: null,
    nb_receipts: null,
    limit_documents: null,
    nb_emails: null,
    limit_emails: null,
    nb_stockage: null,
    limit_stockage: null,
    nb_positions_available: null,
    limit_positions: null,
    current_user_name: null,
    current_user_email: null,
  }

  try {
    if (rootState.company.currentCompany) {
      metaData.company_name = rootState.company.currentCompany.name
      metaData.company_url = rootState.company.currentCompany.url
      metaData.nb_invoices = rootState.company.currentCompany.nbCreatedInvoices || 0
      metaData.nb_quotes = rootState.company.currentCompany.nbCreatedQuotes || 0
      metaData.nb_receipts = rootState.company.currentCompany.nbCreatedReceipts || 0
      metaData.nb_documents = metaData.nb_invoices + metaData.nb_quotes + metaData.nb_receipts
      metaData.limit_documents = rootState.company.currentCompany.options.maxDocuments || 0
      metaData.nb_emails = rootState.company.currentCompany.nbMailsSent || 0
      metaData.limit_emails = rootState.company.currentCompany.options.maxEmails || 0
      metaData.nb_stockage = formatBytes((rootState.company.currentCompany.containerSize || 0) + (rootState.company.currentCompany.containerPrivateSize || 0))
      metaData.limit_stockage = formatBytes(rootState.company.currentCompany.options.maxStorage || 0)
      metaData.nb_positions_available = rootState.company.currentCompany.rhPositionsAvailable.length || 0
      metaData.limit_positions = rootState.company.currentCompany.options.rhUsers || 0

      metaData.current_versions = rootState.company.currentCompany.versions.map(version => {
        return {
          name: version.name,
          label: version.label,
          type: version.type,
        }
      })
    }

    if (rootState.authV3.currentUser) {
      metaData.current_user_name = rootState.authV3.currentUser.first_name + ' ' + rootState.authV3.currentUser.last_name
      metaData.current_user_email = rootState.authV3.currentUser.email
    }
  } catch (e) {
    console.log(e)
  }

  window.chatbot_metadata = metaData
}

export function removeChatbot () {
  const script = document.getElementById("widget-chatbot-js")
  if (script) script.remove()

  // Supprimer aussi les éventuels éléments créés par le script
  const chatbotWidget = document.querySelector(".talkia-chatbot-widget")
  if (chatbotWidget) chatbotWidget.remove()
}
